<script setup lang="ts">
const route = useRoute()
const { appName } = useAppName()
const { locale } = useI18n()
const { initTheme } = useTheme()
await useCenterFavicon()

// Fetch the current center
// Necessary when not using SSR (so no preload middleware)
const { currentCenter, fetch } = useCurrentCenter()
if (!currentCenter.value) await fetch()

onBeforeMount(async () => {
  // TODO: move to a composable, or middleware?
  const { initialize } = useGtag()
  const { currentCenterProfile } = useCurrentCenter()
  if (currentCenterProfile.value?.gtagId) {
    initialize(currentCenterProfile.value.gtagId)
  }

  // As soon as we have fixed setting css variables server-side, we can remove this
  // and pre-set it in the middleware instead.
  initTheme()
})

useHead({
  title: route.meta.title || '',
  titleTemplate: (titleChunk) => {
    return titleChunk
      ? `${titleChunk} - ${appName.value}`
      : appName.value || ''
  },
  htmlAttrs: {
    lang: locale.value,
  },
})
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator color="var(--color-primary-500)" />
      <NuxtErrorBoundary>
        <NuxtPage />
        <template #error="{ error }">
          <AppError
            :error="error"
          />
        </template>
      </NuxtErrorBoundary>
      <ToasterContainer />
    </NuxtLayout>
  </div>
</template>
